import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { InputLabel, TextField } from '@mui/material';
import { ReactComponent as CustomDatePickerIcon } from '../../../Assets/images/svg/calender_icon.svg';


import './customDatePicker.scss';

const CustomDatePicker = ({
  value,
  onChange,
  label,
  placeholder,
  minDate,
  maxDate,
  isDisabled,
  error,
  helperText,
  defaultDate,
  displayFormat = 'DD-MM-YYYY',
}) => {
  return (
    <div className="custom-date-picker-wrapper">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {label && (
          <InputLabel className="custom-date-picker-label">
            {label}
          </InputLabel>
        )}

        <DatePicker
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          minDate={minDate}
          maxDate={maxDate}
          format={displayFormat}
          referenceDate={defaultDate || minDate}
          slots={{
            textField: TextField,
            openPickerIcon: CustomDatePickerIcon,
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              error,
              helperText,
              placeholder: placeholder || 'Choose Date',
            },
            popper: {
              strategy: 'fixed',
              sx: {
                zIndex: '20000 !important',
              },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

CustomDatePicker.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.instanceOf(dayjs),
  ]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  isDisabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  defaultDate: PropTypes.object,
  displayFormat: PropTypes.string,
};

export default CustomDatePicker;
